
export function logError (message, extra) {
  // eslint-disable-next-line no-console
  if (console && console.error) {
    // eslint-disable-next-line no-console
    console.error(message, extra)
  }
}



// WEBPACK FOOTER //
// ./src/tools/logging.js